import { render, staticRenderFns } from "./TestEventsComponent.vue?vue&type=template&id=722b9bcc"
import script from "./TestEventsComponent.vue?vue&type=script&lang=js"
export * from "./TestEventsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../HCP/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports